import { API_URL, PL_UPGRADE_HEADER } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IMenuDataResponseV2 } from 'src/api/getMenu/types';

export const getMenu = async (menuId: string): Promise<IMenuDataResponseV2> => {
  try {
    const res = await fetch(`${API_URL}/menus/${menuId}`, {
      headers: {
        [PL_UPGRADE_HEADER]: 'true',
      },
    });

    if (!res.ok) {
      throw new Error('We have been unable to complete your request.\nPlease try again.');
    }

    const { data }: { data: IMenuDataResponseV2[] } = await res.json();

    return data[0];
  } catch (err) {
    throw new Error(err);
  }
};
